module.exports = __webpack_public_path__ + "img/icon_zuida.909aa292.svg";